export default __webpack_public_path__ + "media/images/svg/fb-icon-solid-d3f72dc0a69fe2680bb4fcbb02ff33d8.svg";